import {
  ToggleFilterChip,
  createToggleFilter,
} from '@spotify/confidence-core-react';

export const CAN_EDIT_FILTER_ID = 'canEdit';

export const CAN_EDIT_DESCRIPTION =
  'Experiments you can edit through ownership or permissions shared with you or your groups.';

export const CAN_EDIT_FILTER = createToggleFilter({
  id: CAN_EDIT_FILTER_ID,
  label: 'Editable by me',
  query: () => '',
  viewer: props => (
    <ToggleFilterChip
      {...props}
      filter={{ ...props.filter, description: CAN_EDIT_DESCRIPTION }}
    />
  ),
});
